import { useUser } from "../context/useUser";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Header from "../components/header";
import Footer from "../components/footer";

const url = process.env.REACT_APP_BACKEND_CONNECTION;

export default function UserProfile() {
  const { user, signOut } = useUser();
  const navigate = useNavigate();
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [emailLookup, setEmailLookup] = useState("");
  const [companies, setCompanies] = useState([]);
  const [foundUserId, setFoundUserId] = useState(null);
  const [showDelegateForm, setShowDelegateForm] = useState(false);

  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
  });

  const [delegateData, setDelegateData] = useState({
    housing_company_id: "",
    expires_at: "",
    reason: ""
  });

  const handleLogout = () => {
    signOut();
    navigate("/signin");
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${url}/user/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify(passwords),
      });

      const data = await res.json();
      if (!res.ok) {
        alert(data.error || "Virhe");
        return;
      }

      alert("Salasana vaihdettu!");
      setPasswords({ oldPassword: "", newPassword: "" });

    } catch (err) {
      alert("Palvelinvirhe.");
    }
  };

  const handleEmailLookup = async () => {
  try {
    const res = await fetch(
      `${url}/admin/user-housing-companies?email=${emailLookup}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    const data = await res.json();

    if (!res.ok) {
      alert(data.error || "Virhe");
      setCompanies([]);
      return;
    }

    setCompanies(data);
    setFoundUserId(data[0].user_id);

  } catch {
    alert("Palvelinvirhe.");
  }
};

const handleGrantDelegate = async (e) => {
  e.preventDefault();

  if (!delegateData.reason.trim()) {
    alert("Valintadelegaatin roolin myöntämiseen täytyy antaa perustelu.");
    return;
  }

  try {
    const res = await fetch(`${url}/admin/housing-company/grant-selection-delegate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify({
        user_id: foundUserId,
        housing_company_id: delegateData.housing_company_id,
        expires_at: delegateData.expires_at,
        reason: delegateData.reason
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      alert(data.error || "Virhe");
      return;
    }
    
    setDelegateData({
      housing_company_id: "",
      expires_at: "",
      reason: ""
    });

    alert("Valintadelegaatin rooli myönnetty.");

  } catch {
    alert("Palvelinvirhe.");
  }
};

  return (
    <>
      <Header />
      <main className="home-container">
        <div className="profile-section profile-header">
          <i className="fa-solid fa-circle-user profile-user-icon" />
          
          <div className="profile-header-text">
            <h1 className="default-title">Käyttäjäprofiili</h1>
            <p className="default-text">{user?.name}</p>
            <p className="default-text">Sähköposti: {user?.email}</p>
          </div>
        </div>

        {user?.is_admin && (
          <div className="profile-section admin-tools-panel">
            <div className="admin-tools-section">
              <h3 className="default-title-small">Ylläpitäjien työkalut</h3>

              <div className="admin-links">
                <button className="admin-link" onClick={() => navigate("/admin/import-users")}>
                  Tuo käyttäjiä
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/housing-company/import-members")}>
                  Tuo taloyhtiöitä ja aseta roolit
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/housing-company/import-staircases")}>
                  Tuo porrastyyppejä
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/housing-company/import-options")}>
                  Tuo valintoja
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/housing-company/option-dependencies")}>
                  Hallitse valintariippuvuuksia
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/housing-company/import-floorplans")}>
                  Tuo pohjapiirrokset
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/housing-company/import-products")}>
                  Tuo tuotteita
                </button>

                <button className="admin-link" onClick={() => navigate("/admin/delegate-history")}>
                  Delegointihistoria
                </button>
              </div>
            </div>

            <div className="admin-tools-section">
              <button
                className="default-title-small dropdown-toggle"
                onClick={() => setShowDelegateForm(!showDelegateForm)}
              >
                Myönnä erityisoikeudet
                <i className={`fa-solid fa-chevron-${showDelegateForm ? "up" : "down"}`}></i>
              </button>

              <div className={`dropdown-content ${showDelegateForm ? "open" : ""}`}>
                <form onSubmit={handleGrantDelegate} className="profile-password-form">

                  <div className="profile-password-field">
                    <label className="default-text">
                      Käyttäjän sähköposti:
                      <input
                        type="email"
                        value={emailLookup}
                        onChange={(e) => setEmailLookup(e.target.value)}
                        required
                      />
                    </label>
                  </div>

                  <button type="button" className="btn submit-btn" onClick={handleEmailLookup}>
                    Hae käyttäjä
                  </button>

                  <div className="profile-password-field">
                    <label className="default-text">
                      Taloyhtiö:
                      <select
                      className="selector-dropdown"
                        value={delegateData.housing_company_id}
                        onChange={(e) =>
                          setDelegateData({
                            ...delegateData,
                            housing_company_id: e.target.value,
                          })
                        }
                        disabled={!companies.length}
                        required
                      >
                        <option value="">Valitse taloyhtiö</option>

                        {companies.map((c) => (
                          <option key={c.housing_company_id} value={c.housing_company_id}>
                            {c.company_name}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>

                  <div className="profile-password-field">
                    <label className="default-text">
                      Voimassa asti:
                      <input
                        type="datetime-local"
                        value={delegateData.expires_at}
                        onChange={(e) =>
                          setDelegateData({
                            ...delegateData,
                            expires_at: e.target.value,
                          })
                        }
                      />
                    </label>
                  </div>

                  <div className="profile-password-field">
                    <label className="default-text">
                      Syy roolin myöntämiselle (pakollinen):
                      <textarea
                        value={delegateData.reason}
                        placeholder="Kirjoita perustelu valintadelegaatin roolin myöntämiselle"
                        onChange={(e) =>
                          setDelegateData({
                            ...delegateData,
                            reason: e.target.value,
                          })
                        }
                        required
                      />
                    </label>
                  </div>

                  <button
                    type="submit"
                    className="btn submit-btn"
                    disabled={
                      !foundUserId ||
                      !delegateData.housing_company_id ||
                      !delegateData.reason
                    }
                  >
                    Myönnä rooli
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}

        <div className="profile-section">
          <button className="default-title-small dropdown-toggle" onClick={() => setShowPasswordForm(!showPasswordForm)}>
            Vaihda salasana
            <i className={`fa-solid fa-chevron-${showPasswordForm ? "up" : "down"}`}></i>
          </button>

          <div className={`dropdown-content ${showPasswordForm ? "open" : ""}`}>
            <form onSubmit={handleChangePassword} className="profile-password-form">
              <div className="profile-password-field">
                <label className="default-text">Vanha salasana:
                  <input
                    type="password"
                    value={passwords.oldPassword}
                    onChange={(e) =>
                      setPasswords({ ...passwords, oldPassword: e.target.value })
                    }
                    required
                  />
                </label>
              </div>

              <div className="profile-password-field">
                <label className="default-text">Uusi salasana:
                  <input
                    type="password"
                    value={passwords.newPassword}
                    onChange={(e) =>
                      setPasswords({ ...passwords, newPassword: e.target.value })
                    }
                    required
                  />
                </label>
              </div>

              <button type="submit" className="btn submit-btn">Vaihda salasana</button>
            </form>
            
          </div>
        </div>

        <div className="profile-section">
          <button className="btn logout-btn" onClick={handleLogout}>
            Kirjaudu ulos
          </button>
        </div>
      </main>
      <Footer />
    </>
  );
}
